"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreConfig = exports.ScoreConfigClassName = void 0;
const ModelCommon_1 = require("../ModelCommon");
exports.ScoreConfigClassName = 'ScoreConfig';
class ScoreConfig extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.ScoreConfigClassName)
            throw new Error(`Tried to create a ${exports.ScoreConfigClassName} from a ${ob.type} object!`);
        super(exports.ScoreConfigClassName, ob);
        this.type = ob.type ?? exports.ScoreConfigClassName;
        this.name = exports.ScoreConfigClassName;
        this.definitions = ob.definitions ?? {};
    }
}
exports.ScoreConfig = ScoreConfig;
